import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import useScribbleTooltip from "../../../../hooks/answeringQuestions/useScribbleTooltip";

const ScribbleTooltipHider = ( props ) => {

  const questionView = useSelector( state => state.questionView );

  const dispatch = useDispatch();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  const { hideScribbleTooltip } = useScribbleTooltip();

  useEffect( () => {
    if ( questionView.scribbleTooltipStatus ) {
      const fadeTooltip = () => {
        setQuestionView( { scribbleTooltipStatus : 2 } );
        timer = setTimeout( hideScribbleTooltip, 1000 );
      };
      let timer = setTimeout( fadeTooltip, 2000 );
      return () => {
        clearTimeout( timer );
      };
    }
  }, [] );

  return props.children || null;

};

export default ScribbleTooltipHider;
